module.exports = __webpack_public_path__ + "static/media/codim.a7668bc4.png";